import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es7.array.includes";
// The geometry check (#76): what is wrong with a stored shape. Pure (no Meteor): the server's job runs it over every
// fan's place (measures), every community (land) and every home (users), and its tests run it on made-up shapes.
// How and why: docs/claude/explain/geometry-check.md.
//
// Each check returns defects { kind, detail }; `kind` is also the i18n key (pages.geometry_check.kinds.<kind>). The
// shape rules themselves (what MongoDB needs, the tools' limits) are the drawing guards' (polygons/shapeRules.js, #205):
// one copy, so the check never calls a shape good that a tool or a save method would refuse.
import { ringRejectReason, areaM2, distanceM, SHAPE_LIMITS } from "../polygons/shapeRules"; // the survey's levels (level = step + 2): neighbourhood, living area, country, world. A place without a level is one
// added on its own. The first two are drawn around the fan's home within a circle of this radius (CreateAreaPage)

export var LEVELS = [2, 3, 4, 5]; // a level a place may be saved with: one of the four, or none (a place added on its own). The save methods refuse
// anything else (#76: levels 1, 6, 7 and 8 came from a survey that kept counting)

export var validLevel = function validLevel(level) {
  return level === undefined || level === null || LEVELS.includes(level);
};
export var LEVEL_RADIUS_M = Object.freeze({
  2: 2000,
  3: 20000
}); // a place of those levels counts as far from home past this many radii (the circle only frames the start: a fan may
// drag a corner out), and as too large past this many times the circle's surface

export var FAR_FACTOR = 3;
export var LARGE_FACTOR = 10; // 'Null Island': every point within this many degrees of (0, 0)

export var NULL_ISLAND_DEG = 1; // far too small for anything drawn on a map (the drawing guards' minimum for a community)

export var TINY_M2 = SHAPE_LIMITS.community.minAreaM2; // the kinds, in the report's order: the shape cannot be used, then where it lies, then its size, then the rest

export var KINDS = ['missing', 'structure', 'not_closed', 'range', 'repeat', 'duplicate', 'cross', 'null_island', 'swapped', 'tiny', 'too_large', 'too_many_points', 'level', 'duplicate_shape', 'orphan', 'few_places', 'not_finished', 'home_range', 'home_null_island'];

var isNum = function isNum(v) {
  return typeof v === 'number' && isFinite(v);
};

var isPos = function isPos(p) {
  return Array.isArray(p) && p.length >= 2 && isNum(p[0]) && isNum(p[1]);
}; // the rings of a Polygon or MultiPolygon as [[ring, …], …] (parts of rings), or null when it is not built like one


export var partsOf = function partsOf(geometry) {
  if (!geometry || !Array.isArray(geometry.coordinates)) return null;
  var c = geometry.coordinates;

  var isRings = function isRings(rs) {
    return Array.isArray(rs) && rs.length > 0 && rs.every(function (r) {
      return Array.isArray(r) && r.every(function (p) {
        return Array.isArray(p);
      });
    });
  };

  if (geometry.type === 'Polygon') return isRings(c) ? [c] : null;
  if (geometry.type === 'MultiPolygon') return c.length && c.every(isRings) ? c : null;
  return null;
};

var allPositions = function allPositions(parts) {
  var _ref;

  return (_ref = []).concat.apply(_ref, _toConsumableArray(parts.map(function (rings) {
    var _ref2;

    return (_ref2 = []).concat.apply(_ref2, _toConsumableArray(rings));
  })));
}; // the outer rings' corners as [lat, lng] (open), for measuring


var outerPoints = function outerPoints(parts) {
  return parts.map(function (rings) {
    return rings[0].slice(0, -1).map(function (p) {
      return [p[1], p[0]];
    });
  });
};

export var surfaceM2 = function surfaceM2(parts) {
  return outerPoints(parts).reduce(function (sum, pts) {
    return sum + areaM2(pts);
  }, 0);
}; // the middle of all corners as [lat, lng]

export var centreOf = function centreOf(parts) {
  var _ref3;

  var pts = (_ref3 = []).concat.apply(_ref3, _toConsumableArray(outerPoints(parts)));

  if (!pts.length) return null;
  return [pts.reduce(function (s, p) {
    return s + p[0];
  }, 0) / pts.length, pts.reduce(function (s, p) {
    return s + p[1];
  }, 0) / pts.length];
}; // a home as [lat, lng] from profile.centerCoordinates ([lng, lat]), or null

export var homeOf = function homeOf(profile) {
  var c = profile && profile.centerCoordinates;
  return isPos(c) ? [c[1], c[0]] : null;
};
/**
 * What is wrong with one stored shape.
 * @param {Object} geometry the GeoJSON geometry as stored
 * @param {Object} opts { multiPolygon: allowed, level: the survey level or null, home: [lat, lng] or null }
 * @returns {Array<{ kind: string, detail?: Object }>}
 */

export var shapeDefects = function shapeDefects(geometry) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var out = [];
  if (!geometry || !Array.isArray(geometry.coordinates) || !geometry.coordinates.length) return [{
    kind: 'missing'
  }];
  var parts = partsOf(geometry);

  if (!parts || geometry.type === 'MultiPolygon' && !opts.multiPolygon) {
    return [{
      kind: 'structure',
      detail: {
        type: geometry.type || null
      }
    }];
  }

  if (!allPositions(parts).every(isPos)) return [{
    kind: 'structure',
    detail: {
      reason: 'invalid'
    }
  }]; // the ring rules on every ring (holes too). A position repeated right after itself is told apart from a corner
  // used twice: the first is a double click, fixed without changing the shape

  var ringKinds = new Set();
  parts.forEach(function (rings) {
    return rings.forEach(function (ring) {
      var reason = ringRejectReason(ring);
      if (!reason) return;
      if (reason === 'too_few' || reason === 'invalid') ringKinds.add('structure');else if (reason === 'duplicate' && ring.some(function (p, i) {
        return i > 0 && p[0] === ring[i - 1][0] && p[1] === ring[i - 1][1];
      })) {
        ringKinds.add('repeat'); // a corner used twice besides the repeat: still a duplicate

        var once = ring.filter(function (p, i) {
          return i === 0 || p[0] !== ring[i - 1][0] || p[1] !== ring[i - 1][1];
        });
        var rest = ringRejectReason(once);
        if (rest && rest !== 'too_few') ringKinds.add(rest);
      } else ringKinds.add(reason);
    });
  });
  KINDS.forEach(function (k) {
    if (ringKinds.has(k)) out.push({
      kind: k
    });
  }); // a ring that cannot be read further (too few points, outside the map): no place or size to judge

  if (ringKinds.has('structure') || ringKinds.has('range')) return out;
  var centre = centreOf(parts);
  var points = allPositions(parts);
  if (points.every(function (p) {
    return Math.abs(p[0]) < NULL_ISLAND_DEG && Math.abs(p[1]) < NULL_ISLAND_DEG;
  })) out.push({
    kind: 'null_island'
  });
  var area = surfaceM2(parts);
  var radius = LEVEL_RADIUS_M[opts.level];

  if (radius && opts.home && centre) {
    var away = distanceM(opts.home, centre);

    if (away > FAR_FACTOR * radius) {
      // lat and lng swapped (Groningen in Somalia): the swapped shape lies near home
      var swapped = distanceM(opts.home, [centre[1], centre[0]]); // (a place simply far from home is no defect: fans choose it so, the user 14 Oct)

      if (swapped <= FAR_FACTOR * radius) out.push({
        kind: 'swapped',
        detail: {
          awayKm: Math.round(away / 1000)
        }
      });
    }
  } // (a shape whose lines cross has no surface to judge: its loops count against each other)


  var tangled = ringKinds.has('cross') || ringKinds.has('duplicate');
  if (!tangled && area < TINY_M2) out.push({
    kind: 'tiny',
    detail: {
      areaM2: Math.round(area * 10) / 10
    }
  });
  if (!tangled && radius && area > LARGE_FACTOR * Math.PI * radius * radius) out.push({
    kind: 'too_large',
    detail: {
      areaKm2: Math.round(area / 1e6)
    }
  });
  var count = points.length - parts.reduce(function (n, rings) {
    return n + rings.length;
  }, 0);
  if (count > SHAPE_LIMITS.community.maxPoints) out.push({
    kind: 'too_many_points',
    detail: {
      points: count
    }
  });
  return out;
}; // a fan's place: its shape, its level

export var measureDefects = function measureDefects(measure, home) {
  var level = isNum(measure.level) ? measure.level : null;
  var out = shapeDefects(measure.geometry, {
    multiPolygon: SHAPE_LIMITS.fanArea.multiPolygon,
    level: level,
    home: home
  });
  if (measure.level !== undefined && measure.level !== null && !LEVELS.includes(measure.level)) out.push({
    kind: 'level',
    detail: {
      level: measure.level
    }
  });
  return out;
}; // a community: its boundary (one made from a list keeps the list's MultiPolygon)

export var communityDefects = function communityDefects(land) {
  return shapeDefects(land.geometry, {
    multiPolygon: !!land.listArea
  });
}; // a home

export var homeDefects = function homeDefects(profile) {
  var c = profile && profile.centerCoordinates;
  if (c === undefined || c === null) return [];
  if (!isPos(c) || c[0] < -180 || c[0] > 180 || c[1] < -90 || c[1] > 90) return [{
    kind: 'home_range'
  }];
  if (Math.abs(c[0]) < NULL_ISLAND_DEG && Math.abs(c[1]) < NULL_ISLAND_DEG) return [{
    kind: 'home_null_island'
  }];
  return [];
}; // the same shape twice for one fan: a key per shape (its coordinates as text)

export var shapeKey = function shapeKey(geometry) {
  return geometry && Array.isArray(geometry.coordinates) ? JSON.stringify(geometry.coordinates) : null;
};